export default __webpack_public_path__ + "static/media/utsav_ghimire_resume_updated.8d7a91f7.pdf";